import { useEffect, useState } from 'react'
import { Input, Divider } from 'antd'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData } from '../CreateMacroDataProvider/actions'
import FormLikeField from './FormLikeField'

DateRangeConfig = ({ fieldKey }) ->

  [{ fieldData }, dispatch] = useCreateMacroData()

  setConfig = (key) -> ({ target: { value }}) ->
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, 'save', 'attributes', key], value)
      )
    )

  <>
    <FormLikeField label="Start attribute">
      <Input
        value={fieldData[fieldKey]?.save?.attributes?[0] or 'startsOn'}
        placeholder={fieldData[fieldKey]?.save?.attributes?[0] or 'Starts on'}
        onChange={setConfig('0')}
      />
    </FormLikeField>
    <FormLikeField label="End attribute">
      <Input
        value={fieldData[fieldKey]?.save?.attributes?[1] or 'endsOn'}
        placeholder={fieldData[fieldKey]?.save?.attributes?[1] or 'Ends on'}
        onChange={setConfig('1')}
      />
    </FormLikeField>
    <Divider />
  </>

export default DateRangeConfig